import { createContext } from '../../utils/create-context.js';

const [HoverCardProvider, useHoverCardContext] = createContext("HoverCardContext");

export { HoverCardProvider, useHoverCardContext };
